import {Injectable} from '@angular/core';
import {Gallery} from 'angular-gallery';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor(private gallery: Gallery) {
  }

  visible = false;

  showGallery(index: number): void {
    const prop = {
      images: [
        {path: '/assets/IMG_1434b.jpg'},
        {path: '/assets/nostromo.jpg'},
        {path: '/assets/tim.jpg'},
        {path: '/assets/kamenz.jpg'},
        {path: '/assets/andy.jpg'},
        {path: '/assets/akustik.jpg'},
        {path: '/assets/bautzen_1.jpg'},
        {path: '/assets/bautzen_2.jpg'},
        {path: '/assets/niesky.jpg'},
        {path: '/assets/nostromo_2.jpg'},

      ],
      index
    };
    this.gallery.load(prop);

    this.visible = true;
  }

  close(): void {

    // TODO Exception is thrown

    // if (this.visible) {
    //
    //   this.gallery.close();
    //   this.visible = false;
    // }
  }
}
